import { useState } from 'react';
import { SketchPicker } from 'react-color';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, InputAdornment, Popover } from '@mui/material';

import TextInput, { TextInputProps } from '~/components/ui/TextInput';

type ColorInputPickerProps = Omit<TextInputProps, 'onChange'> & {
  name: string;
  onChange?: (value: string) => void;
};

export default function ColorInputPickerV2({ name, ...rest }: ColorInputPickerProps) {
  const { control } = useFormContext();

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? 'color-popover' : undefined;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
        return (
          <TextInput
            {...rest}
            id={name}
            value={value}
            onChange={(event) => {
              onChange(event);

              if (rest.onChange) {
                rest.onChange(event.target.value);
              }
            }}
            onBlur={onBlur}
            error={!!error?.message}
            helperText={error?.message}
            InputProps={{
              endAdornment: (
                <>
                  <InputAdornment
                    position="end"
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    sx={{ cursor: 'pointer' }}
                  >
                    <Box
                      style={{ backgroundColor: value }}
                      sx={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '2px',
                        border: value.toLowerCase() === '#ffffff' ? `1px solid #000` : undefined,
                      }}
                    />
                  </InputAdornment>
                  <Popover
                    id={`${id}${value}`}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: -20,
                      horizontal: 'right',
                    }}
                  >
                    <Box width={220}>
                      <SketchPicker
                        color={value}
                        onChange={({ hex }) => {
                          onChange(hex);

                          if (rest.onChange) {
                            rest.onChange(hex);
                          }
                        }}
                        onChangeComplete={({ hex }) => {
                          onChange(hex);

                          if (rest.onChange) {
                            rest.onChange(hex);
                          }
                        }}
                      />
                    </Box>
                  </Popover>
                </>
              ),
            }}
          />
        );
      }}
    />
  );
}
